export default function (editor) {
  const sizeOptions = [
    { id: '', name: 'None' },
    { id: 'xs', name: 'Extra Small' },
    { id: 'sm', name: 'Small' },
    { id: 'md', name: 'Medium' },
    { id: 'lg', name: 'Large' },
    { id: 'xl', name: 'Extra Large' }
  ]

  const visibilityTrait = {
    type: 'select',
    label: 'Visibility',
    name: 'visibility',
    changeProp: true,
    options: [
      { id: 'both', name: 'Desktop and Mobile' },
      { id: 'desktop', name: 'Desktop Only' },
      { id: 'mobile', name: 'Mobile Only ' }
    ]
  }

  function handleVisibilityChange (component) {
    const element = component.getEl()

    if (!element || !element.classList) return

    // Reset visibility
    _.each(['gt-xs', 'lt-sm'], className => element.classList.remove(className))

    const visibility = this.get('visibility')
    if (visibility === 'desktop') {
      element.classList.add('gt-xs')
    } else if (visibility === 'mobile') {
      element.classList.add('lt-sm')
    }
  }

  const marginTraits = [{
    type: 'select',
    label: 'All Margin',
    name: 'ma',
    changeProp: true,
    options: sizeOptions
  }, {
    type: 'select',
    label: 'Top-Bottom Margin',
    name: 'my',
    changeProp: true,
    options: sizeOptions
  }, {
    type: 'select',
    label: 'Left-Right Margin',
    name: 'mx',
    changeProp: true,
    options: sizeOptions
  }, {
    type: 'select',
    label: 'Top Margin',
    name: 'mt',
    changeProp: true,
    options: sizeOptions
  }, {
    type: 'select',
    label: 'Bottom Margin',
    name: 'mb',
    changeProp: true,
    options: sizeOptions
  }, {
    type: 'select',
    label: 'Left Margin',
    name: 'ml',
    changeProp: true,
    options: sizeOptions
  }, {
    type: 'select',
    label: 'Right Margin',
    name: 'mr',
    changeProp: true,
    options: sizeOptions
  }]

  const allMarginClassnames = _(marginTraits).map(marginTrait => {
    return _.map(sizeOptions, size => 'q-' + marginTrait.name + '-' + size.id)
  }).flatten().value()

  function handleMarginChange (component) {
    const element = component.getEl()

    if (!element || !element.classList) return

    // Reset visibility
    _.each(allMarginClassnames, className => element.classList.remove(className))

    _.each(marginTraits, marginTrait => {
      const size = this.get(marginTrait.name)

      if (size) {
        element.classList.add('q-' + marginTrait.name + '-' + size)
      }
    })
  }

  function setupMarginListeners (component) {
    _.each(marginTraits, marginTrait => {
      component.on('change:' + marginTrait.name, handleMarginChange)
    })
  }

  const paddingTraits = [{
    type: 'select',
    label: 'All Padding',
    name: 'pa',
    changeProp: true,
    options: sizeOptions
  }, {
    type: 'select',
    label: 'Top-Bottom Padding',
    name: 'py',
    changeProp: true,
    options: sizeOptions
  }, {
    type: 'select',
    label: 'Left-Right Padding',
    name: 'px',
    changeProp: true,
    options: sizeOptions
  }, {
    type: 'select',
    label: 'Top Padding',
    name: 'pt',
    changeProp: true,
    options: sizeOptions
  }, {
    type: 'select',
    label: 'Bottom Padding',
    name: 'pb',
    changeProp: true,
    options: sizeOptions
  }, {
    type: 'select',
    label: 'Left Padding',
    name: 'pl',
    changeProp: true,
    options: sizeOptions
  }, {
    type: 'select',
    label: 'Right Padding',
    name: 'pr',
    changeProp: true,
    options: sizeOptions
  }]

  const allPaddingClassnames = _(paddingTraits).map(paddingTrait => {
    return _.map(sizeOptions, size => 'q-' + paddingTrait.name + '-' + size.id)
  }).flatten().value()

  function handlePaddingChange (component) {
    const element = component.getEl()

    if (!element || !element.classList) return

    // Reset visibility
    _.each(allPaddingClassnames, className => element.classList.remove(className))

    _.each(paddingTraits, paddingTrait => {
      const size = this.get(paddingTrait.name)

      if (size) {
        element.classList.add('q-' + paddingTrait.name + '-' + size)
      }
    })
  }

  function setupPaddingListeners (component) {
    _.each(paddingTraits, paddingTrait => {
      component.on('change:' + paddingTrait.name, handlePaddingChange)
    })
  }

  editor.DomComponents.addType('grid-row', {
    model: {
      defaults: {
        tagName: 'div',
        draggable: 'body, body *, #wrapper, .full-width-page, .centered-page, .col, .col-12, .col-3, .col-4, .col-xs-auto',
        droppable: '.col, .col-12, .col-xs-auto, .col-xs-6, .col-xs-3, .col-xs-4',
        traits: [{
          type: 'select',
          label: 'Horizontal Alignment',
          name: 'justify',
          changeProp: true,
          options: [
            { id: 'start', name: 'Left' },
            { id: 'end', name: 'Right' },
            { id: 'center', name: 'Center' },
            { id: 'between', name: 'Between' },
            { id: 'evenly', name: 'Evenly' }
          ]
        }, {
          type: 'select',
          label: 'Vertical Alignment',
          name: 'items',
          changeProp: true,
          options: [
            { id: 'start', name: 'Top' },
            { id: 'end', name: 'Bottom' },
            { id: 'center', name: 'Center' }
          ]
        },
        visibilityTrait,
        ...marginTraits
        ],
        justify: 'center',
        items: 'center',
        visibility: 'both'
      },
      init () {
        this.on('change:justify', this.handleJustifyChange)
        this.on('change:items', this.handleItemsChange)
        this.on('change:visibility', handleVisibilityChange)
        setupMarginListeners(this)
      },

      handleJustifyChange (component) {
        const element = component.getEl()

        if (!element || !element.classList) return

        // Reset justify
        _.each(['justify-start', 'justify-end', 'justify-center', 'justify-between', 'justify-evenly'], className => element.classList.remove(className))

        element.classList.add('justify-' + this.get('justify'))
      },

      handleItemsChange (component) {
        const element = component.getEl()

        if (!element || !element.classList) return

        // Reset items
        _.each(['items-start', 'items-end', 'items-center'], className => element.classList.remove(className))

        element.classList.add('items-' + this.get('items'))
      }
    }
  })

  editor.DomComponents.addType('grid-column', {
    model: {
      defaults: {
        tagName: 'div',
        draggable: '.row',
        droppable: true,
        traits: [
          visibilityTrait,
          {
            type: 'select',
            label: 'Horizontal Alignment',
            name: 'text-align',
            changeProp: true,
            options: [
              { id: 'left', name: 'Left' },
              { id: 'center', name: 'Center' },
              { id: 'right', name: 'Right' }
            ]
          },
          ...paddingTraits
        ],
        visibility: 'both',
        pa: 'sm',
        'text-align': 'center'
      },
      init () {
        this.on('change:visibility', handleVisibilityChange)
        this.on('change:text-align', this.handleTextAlignChange)
        setupPaddingListeners(this)
      },
      handleTextAlignChange (component) {
        const element = component.getEl()

        if (!element || !element.classList) return

        // Reset items
        _.each(['text-left', 'text-right', 'text-center'], className => element.classList.remove(className))

        element.classList.add('text-' + this.get('text-align'))
      }
    }
  })
}
